module.exports = __webpack_public_path__ + "img/header.4a1ed8cf.png";